import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/content_arrows/down-small-arrow.svg")